module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_oc-3565b4b678ca7f70169ab19afc3baccb.gif";